// extracted by mini-css-extract-plugin
export var legendIndicator = "_e5-1";
export var legendRight = "_e5-0";